<template>
  <div>
    <el-input :size="size" placeholder="请选择模型" :value="text" readonly>
      <table class="property-field-table" cellspacing="0" cellpadding="0" slot="append">
        <tr>
          <td @click="clear">&times;</td>
          <td @click="toSelect">选择模型</td>
        </tr>
      </table>
    </el-input>
    <model-select-dialog ref="modelSelectDialog" :dataType="dataType" :configColumn="configColumn" :configCondition="configCondition" :configOperation="configOperation" @save="onSave" :endpoint="endpoint"></model-select-dialog>
  </div>
</template>

<script>
import ModelSelectDialog from '../model/ModelSelectDialog'

export default {
  name: 'model-select-button',
  components: {
    ModelSelectDialog,
  },
  props: {
    endpoint: { type: String, required: true },
    property: { type: Object, required: true },
    size: { type: String, required: false, default: 'mini' },
    dataType: { type: String, required: false },
    configColumn: { type: Boolean, required: false },
    configCondition: { type: Boolean, required: false },
    configOperation: { type: Boolean, required: false }
  },
  data () {
    return {
      text: ''
    }
  },
  watch: {
    'property.value': {
      handler: function (val) {
        this.text = !val ? '' : JSON.parse(val).name
      },
      immediate: true
    }
  },
  methods: {
    clear () {
      this.property.value = undefined
      this.text = ''
      this.$emit('change')
    },
    toSelect () {
      this.$refs.modelSelectDialog.open(this.property.value)
    },
    onSave (model) {
      this.property.value = JSON.stringify(model)
      this.text = model.name
      this.$emit('change')
    }
  }
}
</script>
